<div class="main_body">
  <app-page-header
    [title]="i18n.toolbar.title"
    icon="support"
    [subtitle]="i18n.subtitle" />

  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="form-container">
          <mat-stepper #supportStepper linear animationDuration="0ms" class="support-stepper">
            <mat-step [stepControl]="supportForm" [editable]="!submissionCompleted()">
              <ng-template matStepLabel>
                <span i18n="@@support.step.input">入力</span>
              </ng-template>

              <form [formGroup]="supportForm" class="support-form">

            <!-- セクション1: ログイン中のお客様情報 -->
            <div class="form-section">
              <h4 class="support-section-title">
                <mat-icon class="support-section-title__icon">person</mat-icon>
                <span i18n="@@support.section.customerInfo">お客様情報</span>
              </h4>

              <div class="form-grid">
                <mat-form-field appearance="outline" class="form-field form-field--locked form-grid__full">
                  <mat-label i18n="@@support.label.section">セクション</mat-label>
                  <input matInput formControlName="sectionName" readonly />
                  @if (isIdentityLoading()) {
                    <mat-spinner matSuffix diameter="20" />
                  }
                  @if (!isIdentityLoading()) {
                    <mat-icon matSuffix class="field-lock" aria-hidden="true">lock</mat-icon>
                  }
                  @if (!isIdentityLoading()) {
                    <mat-hint i18n="@@support.hint.accountInfoAuto">ログイン情報から自動入力されています</mat-hint>
                  }
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field"
                                [class.form-field--locked]="isIdentityLoading() || !!identity()?.name">
                  <mat-label i18n="@@support.label.name">お名前</mat-label>
                  <input matInput formControlName="name"
                         [readonly]="isIdentityLoading() || !!identity()?.name" />
                  @if (isIdentityLoading()) {
                    <mat-spinner matSuffix diameter="20" />
                  }
                  @if (!isIdentityLoading() && identity()?.name) {
                    <mat-icon matSuffix class="field-lock" aria-hidden="true">lock</mat-icon>
                  }
                  @if (!isIdentityLoading() && identity()?.name) {
                    <mat-hint i18n="@@support.hint.accountInfoAuto">ログイン情報から自動入力されています</mat-hint>
                  }
                  <mat-error i18n="@@support.error.required">必須項目です</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field"
                                [class.form-field--locked]="isIdentityLoading() || (!!identity()?.email && !isEmailEditing())">
                  <mat-label i18n="@@support.label.email">メールアドレス</mat-label>
                  <input matInput formControlName="email" type="email"
                         [readonly]="isIdentityLoading() || (!!identity()?.email && !isEmailEditing())" />
                  @if (isIdentityLoading()) {
                    <mat-spinner matSuffix diameter="20" />
                  }
                  @if (!isIdentityLoading() && identity()?.email && !isEmailEditing()) {
                    <mat-icon matSuffix class="field-lock" aria-hidden="true">lock</mat-icon>
                  }
                  @if (!isIdentityLoading() && identity()?.email && !isEmailEditing()) {
                    <mat-hint i18n="@@support.hint.accountInfoAuto">ログイン情報から自動入力されています</mat-hint>
                  }
                  @if (!isIdentityLoading() && !identity()?.email) {
                    <mat-hint i18n="@@support.hint.email">スタッフ登録時のメールアドレス</mat-hint>
                  }
                  <mat-error i18n="@@support.error.email">有効なメールアドレスを入力してください</mat-error>
                </mat-form-field>

                @if (!isIdentityLoading() && identity()?.email) {
                  <mat-checkbox class="email-edit-toggle form-grid__full" formControlName="changeEmail"
                                (change)="toggleEmailEditing($event.checked)">
                    <span i18n="@@support.checkbox.changeEmail">受信メールアドレスを変更する</span>
                  </mat-checkbox>
                }
              </div>
            </div>

            <div class="form-divider"></div>

            <!-- セクション2: お問い合わせ詳細 -->
            <div class="form-section">
              <h4 class="support-section-title">
                <mat-icon class="support-section-title__icon">description</mat-icon>
                <span i18n="@@support.section.details">お問い合わせ詳細</span>
              </h4>

              <div class="form-grid">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label i18n="@@support.label.reason">お問い合わせ種別</mat-label>
                  <mat-select formControlName="reason" panelClass="support-select-panel">
                    <mat-option value="" i18n="@@support.option.select">選択してください</mat-option>
                    <mat-option value="hardware" i18n="@@support.option.hardware">ハードウェアについて</mat-option>
                    <mat-option value="software" i18n="@@support.option.software">ソフトウェアについて</mat-option>
                    <mat-option value="system" i18n="@@support.option.system">クラウドシステムについて</mat-option>
                    <mat-option value="data" i18n="@@support.option.data">データについて</mat-option>
                    <mat-option value="Instructions not clear" i18n="@@support.option.instructions">説明書について</mat-option>
                    <mat-option value="Complex functionality" i18n="@@support.option.service">サービス全体について</mat-option>
                  </mat-select>
                  <mat-error i18n="@@support.error.required">必須項目です</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field">
                  <mat-label i18n="@@support.label.subject">件名</mat-label>
                  <input matInput formControlName="subject" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field form-grid__full">
                  <mat-label i18n="@@support.label.description">お問い合わせ内容</mat-label>
                  <textarea matInput formControlName="description" rows="6"></textarea>
                  <mat-hint i18n="@@support.hint.description">データに関するお問い合わせは、ユーザー名・日付等の関連情報をお知らせください</mat-hint>
                  <mat-error i18n="@@support.error.required">必須項目です</mat-error>
                </mat-form-field>
              </div>
            </div>

                <!-- Form Actions -->
                <div class="form-actions">
                  <button mat-stroked-button type="button" (click)="clearForm()">
                    <mat-icon>refresh</mat-icon>
                    <span i18n="@@support.button.clear">クリア</span>
                  </button>
                  <button mat-flat-button color="primary" type="button"
                          [disabled]="supportForm.invalid || isIdentityLoading() || !selectedSection()"
                          (click)="reviewForm(supportStepper)">
                    <mat-icon>navigate_next</mat-icon>
                    <span i18n="@@support.button.review">入力内容を確認する</span>
                  </button>
                </div>
              </form>
            </mat-step>

            <mat-step [completed]="submissionCompleted()" [editable]="!submissionCompleted()">
              <ng-template matStepLabel>
                <span i18n="@@support.step.confirm">確認</span>
              </ng-template>

              <section class="confirmation-panel" aria-labelledby="support-confirmation-title"
                       [attr.aria-busy]="isSubmitting()">
                <div class="step-heading">
                  <mat-icon aria-hidden="true">fact_check</mat-icon>
                  <div>
                    <h4 id="support-confirmation-title" i18n="@@support.confirm.title">この内容で送信しますか？</h4>
                    <p i18n="@@support.confirm.description">お問い合わせ内容と受付メールの送信先をご確認ください。</p>
                  </div>
                </div>

                <dl class="confirmation-list">
                  <div class="confirmation-item">
                    <dt i18n="@@support.label.section">セクション</dt>
                    <dd>{{ supportForm.get('sectionName')?.value }}</dd>
                  </div>
                  <div class="confirmation-item">
                    <dt i18n="@@support.label.name">お名前</dt>
                    <dd>{{ supportForm.get('name')?.value }}</dd>
                  </div>
                  <div class="confirmation-item confirmation-item--email">
                    <dt i18n="@@support.confirm.receiptEmail">受付メールの送信先</dt>
                    <dd>{{ supportForm.get('email')?.value }}</dd>
                  </div>
                  <div class="confirmation-item">
                    <dt i18n="@@support.label.reason">お問い合わせ種別</dt>
                    <dd>
                      @switch (supportForm.get('reason')?.value) {
                        @case ('hardware') { <span i18n="@@support.option.hardware">ハードウェアについて</span> }
                        @case ('software') { <span i18n="@@support.option.software">ソフトウェアについて</span> }
                        @case ('system') { <span i18n="@@support.option.system">クラウドシステムについて</span> }
                        @case ('data') { <span i18n="@@support.option.data">データについて</span> }
                        @case ('Instructions not clear') { <span i18n="@@support.option.instructions">説明書について</span> }
                        @case ('Complex functionality') { <span i18n="@@support.option.service">サービス全体について</span> }
                      }
                    </dd>
                  </div>
                  <div class="confirmation-item">
                    <dt i18n="@@support.label.subject">件名</dt>
                    <dd>
                      @if (supportForm.get('subject')?.value) {
                        {{ supportForm.get('subject')?.value }}
                      } @else {
                        <span i18n="@@support.value.empty">（未入力）</span>
                      }
                    </dd>
                  </div>
                  <div class="confirmation-item confirmation-item--full">
                    <dt i18n="@@support.label.description">お問い合わせ内容</dt>
                    <dd class="confirmation-message">{{ supportForm.get('description')?.value }}</dd>
                  </div>
                </dl>

                <div class="form-actions">
                  <button mat-stroked-button type="button" [disabled]="isSubmitting()"
                          (click)="supportStepper.previous()">
                    <mat-icon>arrow_back</mat-icon>
                    <span i18n="@@support.button.edit">修正する</span>
                  </button>
                  <button mat-flat-button color="primary" type="button"
                          [disabled]="isSubmitting()"
                          (click)="submitForm(supportStepper)">
                    @if (isSubmitting()) {
                      <mat-spinner class="button-spinner" diameter="20" aria-label="送信中"
                                   i18n-aria-label="@@support.aria.submitting" />
                    } @else {
                      <mat-icon>send</mat-icon>
                    }
                    @if (isSubmitting()) {
                      <span i18n="@@support.aria.submitting">送信中</span>
                    } @else {
                      <span i18n="@@support.button.confirmSubmit">この内容で送信する</span>
                    }
                  </button>
                </div>
              </section>
            </mat-step>

            <mat-step>
              <ng-template matStepLabel>
                <span i18n="@@support.step.complete">完了</span>
              </ng-template>

              <section class="completion-panel" aria-labelledby="support-completion-title" aria-live="polite">
                <mat-icon class="completion-panel__icon" aria-hidden="true">mark_email_read</mat-icon>
                <h4 id="support-completion-title" i18n="@@support.complete.title">送信が完了しました</h4>
                <p i18n="@@support.complete.receiptPrefix">受付メールを次のメールアドレスに送信しました。</p>
                <p class="completion-panel__email">{{ submittedEmail() }}</p>
                <p class="completion-panel__note" i18n="@@support.complete.note">
                  メールが届くまで数分かかる場合があります。届かない場合は、迷惑メールフォルダをご確認のうえ、数分待ってから再度お試しください。
                </p>

                <details class="submitted-summary">
                  <summary i18n="@@support.complete.showSubmitted">送信内容を確認する</summary>
                  <dl class="submitted-summary__list">
                    <div>
                      <dt i18n="@@support.label.subject">件名</dt>
                      <dd>
                        @if (supportForm.get('subject')?.value) {
                          {{ supportForm.get('subject')?.value }}
                        } @else {
                          <span i18n="@@support.value.empty">（未入力）</span>
                        }
                      </dd>
                    </div>
                    <div>
                      <dt i18n="@@support.label.description">お問い合わせ内容</dt>
                      <dd class="confirmation-message">{{ supportForm.get('description')?.value }}</dd>
                    </div>
                  </dl>
                </details>

                <div class="form-actions completion-panel__actions">
                  <button mat-flat-button color="primary" type="button"
                          (click)="returnToSupportTop(supportStepper)">
                    <mat-icon>support_agent</mat-icon>
                    <span i18n="@@support.button.backToTop">サポートトップへ戻る</span>
                  </button>
                </div>
              </section>
            </mat-step>
          </mat-stepper>
        </div>

        <!-- 注意書き -->
        <div class="support-notice">
          <mat-icon>info_outline</mat-icon>
          <p i18n="@@support.notice.disclaimer">
            こちらの問い合わせでは、クラウドサービスの技術的な内容に関するお問い合わせ以外は、ご案内・お調べすることができません。契約に関する内容については、別途メール・お電話等にて運営管理会社（PLIMES株式会社）担当者までお問い合わせ下さい。
          </p>
        </div>
      </section>
    </div>
  </div>
</div>
